var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"styled-form styled-form--white-box styled-form--empty"},[_c('div',{staticClass:"styled-form__overlay"},[_c('div',{staticClass:"preloader"})])])
}]

export { render, staticRenderFns }